import { useRef } from 'react';
export default (input) => {
    const touchStart = useRef(null);
    const touchEnd = useRef(null);
    const minSwipeDistance = 10;
    const onTouchStart = (e) => {
        var _a, _b, _c;
        touchEnd.current = null; // otherwise the swipe is fired even with usual touch events
        touchStart.current = (_c = (_b = (_a = e.targetTouches) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.clientY) !== null && _c !== void 0 ? _c : null;
    };
    const onTouchMove = (e) => {
        var _a, _b, _c;
        touchEnd.current = (_c = (_b = (_a = e.targetTouches) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.clientY) !== null && _c !== void 0 ? _c : null;
    };
    const onTouchEnd = () => {
        if (!touchStart.current || !touchEnd.current)
            return;
        const distance = touchStart.current - touchEnd.current;
        const isUpSwipe = distance > minSwipeDistance;
        const isDownSwipe = distance < -minSwipeDistance;
        const drawerState = isUpSwipe ? 'full' : 'half';
        if (isUpSwipe || isDownSwipe) {
            input.onSwipe();
            input.setDrawerState(drawerState);
            // Scroll to the top when the drawer state changes to full
            if (input.drawerRef.current && drawerState === 'full') {
                input.drawerRef.current.scrollTo(0, 0);
            }
        }
    };
    return {
        onTouchStart,
        onTouchMove,
        onTouchEnd,
    };
};
